import React from "react";
import PropTypes from "prop-types";
import styled, { css } from "styled-components";

// data
import { trackHeaderLoginClicked } from "core/trackEvent.js";

// Auth
import { LOGIN_MODE } from "frontend/hooks/useAuth";

// context
import { useSiteHeader } from "core/SiteHeader/context/useSiteHeader.js";

// components
import Button from "core/Button";

// styles
import { convertPxToRem } from "frontend/components/helpers";
const LoginButtonStyled = styled(Button)`
    height: ${convertPxToRem(40)};
    cursor: ${({ isDisabled }) => (isDisabled ? "not-allowed" : "auto")};
`;

// component
export const LoginButton = ({ onFocus, isDisabled }) => {
    const { confirmAuth, isDarkMode } = useSiteHeader();
    const onClick = () => {
        confirmAuth({ mode: LOGIN_MODE });
    };

    return (
        <LoginButtonStyled
            onClick={onClick}
            darkMode={isDarkMode}
            size="lg"
            styleType="outline"
            onFocus={onFocus}
            disabled={isDisabled}
            onMouseDown={trackHeaderLoginClicked}
        >
            Log In
        </LoginButtonStyled>
    );
};

export default LoginButton;

// prop-types
LoginButton.propTypes = {
    onFocus: PropTypes.func,
    isDisabled: PropTypes.bool
};
